"use strict";
exports.__esModule = true;
var toCamelCase = function (str) {
    return (str === null || str === void 0 ? void 0 : str.toLowerCase().replace(/[()]/g, '').replace(/([-_ ][a-z0-9])/g, function (group) { return group.toUpperCase().replace(/[-_ ]/g, ''); })) || '';
};
exports["default"] = toCamelCase;
